import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 10px;

  > label {
    margin-bottom: 10px;
  }
`;
